import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import AutoComplete from '../shared/AutoComplete';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing.unit,
  },
});


const LineItem = ({ lineItem, onLineItemFormChange, onAmountChange, onRemoveLineItem, expenseAccounts, index, unAuthorized, onLineItemAutoCompleteChange, classes }) => {
  const { description, expense_account_id, id } = lineItem;
  const amount = lineItem.amount < 0 ? -lineItem.amount : lineItem.amount;

  const convertToExpenseAccountName = accountId => {
    const account = expenseAccounts.filter(acct => {
      return acct.id === Number(accountId);
    });
    if (account[0]) {
      return account[0].account_name;
    }
    return "";
  };

  return (
    <TableRow>
      <TableCell>
          <AutoComplete data={expenseAccounts} fieldLabel="Account" dataKey={'account_name'} unAuthorized={unAuthorized} onItemSelect={onLineItemAutoCompleteChange(id)} value={convertToExpenseAccountName(expense_account_id) } name='expense_account_id'/>
      </TableCell>
      <TableCell>
        <TextField
          name="description"
          disabled={unAuthorized}
          id="description"
          label="Memo"
          className={classes.textField}
          value={description}
          onChange={onLineItemFormChange(id)}
          margin="normal"
        />
      </TableCell>
      <TableCell numeric>
        {/* Amount */}
        <TextField
          disabled={unAuthorized}
          name="amount"
          id="amount"
          label="Amount"
          className={classes.textField}
          value={amount}
          onChange={onAmountChange(id)}
          margin="normal"
        />

      </TableCell>
      <TableCell>
        <Tooltip title="Delete">
          <div>
        <IconButton aria-label="Delete" disabled={unAuthorized} onClick={onRemoveLineItem(lineItem, index)}>
          <DeleteIcon />
        </IconButton>
        </div>
      </Tooltip>
      </TableCell>
    </TableRow>
    );
  };


export default withStyles(styles)(LineItem);


LineItem.propTypes = {
    lineItem: PropTypes.shape({
      description: PropTypes.string.isRequired,
      amount: PropTypes.string.isRequired,
      expense_account_id: PropTypes.string.isRequired
    }).isRequired,
    onLineItemFormChange: PropTypes.func.isRequired,
    onAmountChange: PropTypes.func.isRequired,
    onRemoveLineItem: PropTypes.func.isRequired,
    expenseAccounts: PropTypes.array.isRequired
    // expense_accounts: PropTypes.arrayOf(PropTypes.shape({
    //   account_code: PropTypes.string.isRequired,
    //   account_name: PropTypes.string.isRequired,
    //   id: PropTypes.number.isRequired
    // })).isRequired
  };



// WEBPACK FOOTER //
// ./src/components/entries/LineItem.js